<template>
  <div style="overflow: hidden;">
    <van-radio-group v-model="selectValue">
      <van-radio
        v-for="item in options"
        :name="item.order"
        :key="item.order"
        icon-size="20px"
        style="margin-bottom: 20px;"
        >{{ getLabel(item.format, item.text) }}</van-radio
      >
    </van-radio-group>
  </div>
</template>
<script>
import { RadioGroup, Radio } from "vant";
export default {
  name: "radio-group",
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: String,
    options: {
      type: Array,
      default: () => [],
    },
    labelFormat: {
      type: Function,
      required: true,
    },
    readonly: Boolean,
  },
  computed: {
    selectValue: {
      get() {
        const int = Number.parseInt(this.$props.value);
        return isNaN(int) ? null : int;
      },
      set(value) {
        if (this.$props.readonly) {
          return;
        }
        this.$emit("change", `${value}`);
      },
    },
  },
  methods: {
    getLabel(format, text) {
      return this.$props.labelFormat(format, text);
    },
  },
};
</script>
